import { render, staticRenderFns } from "./publishIndex.vue?vue&type=template&id=66dc8b06&"
import script from "./publishIndex.vue?vue&type=script&lang=js&"
export * from "./publishIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports